import { schema } from 'normalizr'
import { mergeRight, over, map, lensProp } from 'ramda'
import { formatIdAttribute } from 'utils/harnesses'

const pinsLens = lensProp('pins')
const harness = new schema.Entity(
  'harnesses',
  {},
  {
    idAttribute: formatIdAttribute,
    processStrategy: (value) => {
      const { cavityType } = value
      const mergeCavityType = mergeRight({ cavityType })

      return over(pinsLens, map(mergeCavityType), value)
    },
  }
)

const module = new schema.Entity(
  'modules',
  {
    harnesses: [harness],
  },
  {
    idAttribute: 'moduleName',
  }
)

export const harnessesSchema = { modules: [module] }
